const getThreadIdFromURL = (state, props) => {
  const {
    match
  } = props;
  const {
    threadId
  } = match && match.params;
  return threadId && !isNaN(threadId) ? parseInt(threadId, 10) : undefined;
};
export default getThreadIdFromURL;